import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import RadioGroupWrapper from '@components/forms/common/RadioGroupWrapper.component.jsx';
import SimpleRadio from '@components/forms/common/SimpleRadio.component.jsx';
import { surveyOptions } from '@components/forms/data/surveyOptions.data.js';

const SourceQuestion = forwardRef(({ control, errors }, ref) => {
  const { t } = useTranslation();
  const {
    label,
    options: optionLabels,
    validation,
  } = t('printer.form.fields.source', {
    returnObjects: true,
  });

  return (
    <Controller
      name="source"
      control={control}
      rules={{
        required: validation?.required,
      }}
      render={({ field: { onChange, value } }) => (
        <RadioGroupWrapper
          ref={ref}
          label={label}
          value={value}
          onChange={onChange}
          error={errors.source}
        >
          {surveyOptions.map((option) => (
            <SimpleRadio
              key={option.id}
              option={option}
              label={(optionLabels && optionLabels[option?.key]) ?? ''}
            />
          ))}
        </RadioGroupWrapper>
      )}
    />
  );
});

SourceQuestion.propType = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

export default SourceQuestion;
